// libraries
import React, { useState, useEffect } from 'react'
import clsx from 'clsx'

export default function Guidelines() {

    // show / hide grid
    const [isGridVisible, setIsGridVisible] = useState(false)

    const showHideGrid = () => {
        setIsGridVisible((prev) => !prev)
    }

    // enable / disable grid by pressing shift+g (same shortcut as figma)
    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.shiftKey && event.key.toLowerCase() === 'g') {
                event.preventDefault()
                showHideGrid()
            }
        }

        window.addEventListener('keydown', handleKeyDown)

        return () => {
            window.removeEventListener('keydown', handleKeyDown)
        }
    }, [])

    return (
        <>

            <button onClick={showHideGrid} className='guidelines-button'>
                Grid
            </button>

            <div className='breakpoint-indicator'></div>

            <div className={clsx('guidelines-grid', isGridVisible && 'visible')}>
                <div className='grid-container'>
                    <div className='grid-row'>
                        
                        <div className='c-xxs-3 c-md-1'>
                            <div className='block'>1</div>
                        </div>

                        <div className='c-xxs-3 c-md-1'>
                            <div className='block'>2</div>
                        </div>

                        <div className='c-xxs-3 c-md-1'>
                            <div className='block'>3</div>
                        </div>

                        <div className='c-xxs-3 c-md-1'>
                            <div className='block'>4</div>
                        </div>

                        <div className='c-md-1'>
                            <div className='block'>5</div>
                        </div>

                        <div className='c-md-1'>
                            <div className='block'>6</div>
                        </div>

                        <div className='c-md-1'>
                            <div className='block'>7</div>
                        </div>

                        <div className='c-md-1'>
                            <div className='block'>8</div>
                        </div>

                        <div className='c-md-1'>
                            <div className='block'>9</div>
                        </div>

                        <div className='c-md-1'>
                            <div className='block'>10</div>
                        </div>

                        <div className='c-md-1'>
                            <div className='block'>11</div>
                        </div>

                        <div className='c-md-1'>
                            <div className='block'>12</div>
                        </div>

                    </div>
                </div>
            </div>

        </>
    )
}